import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

const ProjectIdeaMoved = ({
  events = [],
  ownerIdea,
}: NotificationContentProps) => {
  // Ideas moved by a challenge automation have no user attached to the event
  const movedBySystem = !events.some((event) => event?.ownerUser);
  return (
    <Trans
      i18nKey={
        movedBySystem
          ? "notifications.projectIdeaMovedAutomatically"
          : "notifications.projectIdeaMoved"
      }
      values={{
        name: movedBySystem ? "" : util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
        prevStage: events[0]?.previousLane || "Deleted",
        newStage: events[events.length - 1]?.newLane || "Deleted",
      }}
    />
  );
};

export default ProjectIdeaMoved;
